<template>
  <div
    v-if="selectedActivity && descriptions[selectedActivity]"
    class="flex w-full mx-auto p-4 items-center justify-center mt-4"
  >
    <span class="flex text-sm font-bold m-0 py-4 text-center h-full items-center break-words">
      {{ descriptions[selectedActivity] }}
    </span>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  selectedActivity: {
    type: String,
    default: ''
  },
  descriptions: {
    type: Object,
    default: () => ({})
  }
});
</script>
